import { publicProfileActionTypes } from './Constants';

const initialState = {
	loading: true,
	loadingHeaderInfo: true,
	userInfo: {},
	publicLists: [],
	publicFolders: [],
	loadingPublicQuestions: false,
	publicQuestionsData: {
		total_count: 0,
		results: [],
	},
	loadingPublicAnswers: false,
	publicAnswersData: {
		total_count: 0,
		results: [],
	},
	loadingAchievements: true,
	achievements: [],
};

export default function publicProfileReducer(state = initialState, action) {
	const { type, payload } = action;
	const { userInfo, lists, folders, data } = payload || {};

	switch (type) {
		case publicProfileActionTypes.CHECK_USER_NAME_REQUEST:
		case publicProfileActionTypes.GET_PUBLIC_LISTS_REQUEST:
		case publicProfileActionTypes.GET_PUBLIC_FOLDERS_REQUEST:
		case publicProfileActionTypes.SET_LOADING:
			return {
				...state,
				loading: true,
			};

		case publicProfileActionTypes.GET_PUBLIC_PROFILE_INFO_REQUEST:
			return {
				...state,
				loadingHeaderInfo: true,
			};

		case publicProfileActionTypes.CHECK_USER_NAME_SUCCESS:
			return {
				...state,
				loading: false,
				...data,
			};

		case publicProfileActionTypes.GET_PUBLIC_PROFILE_INFO_SUCCESS:
			return {
				...state,
				userInfo,
				loadingHeaderInfo: false,
			};

		case publicProfileActionTypes.GET_PUBLIC_LISTS_SUCCESS:
			return {
				...state,
				loading: false,
				publicLists: lists,
			};

		case publicProfileActionTypes.GET_PUBLIC_FOLDERS_SUCCESS:
			return {
				...state,
				loading: false,
				publicFolders: folders,
			};

		case publicProfileActionTypes.CHECK_USER_NAME_ERROR:
			return {
				...state,
				loading: false,
			};
		case publicProfileActionTypes.GET_PUBLIC_PROFILE_INFO_ERROR:
			return {
				...state,
				loading: false,
				loadingHeaderInfo: false,
			};

		case publicProfileActionTypes.GET_PUBLIC_LISTS_ERROR:
		case publicProfileActionTypes.GET_PUBLIC_FOLDERS_ERROR:
			return {
				...state,
				loading: false,
			};

		case publicProfileActionTypes.GET_PUBLIC_QUESTIONS_REQUEST:
			return {
				...state,
				loadingPublicQuestions: !data,
			};

		case publicProfileActionTypes.GET_PUBLIC_QUESTIONS_SUCCESS:
			return {
				...state,
				loadingPublicQuestions: false,
				publicQuestionsData: data,
			};
		case publicProfileActionTypes.GET_PUBLIC_QUESTIONS_ERROR:
			return {
				...state,
				loadingPublicQuestions: false,
				showContentError: true,
			};

		case publicProfileActionTypes.GET_PUBLIC_ANSWERS_REQUEST:
			return {
				...state,
				loadingPublicAnswers: !data,
			};
		case publicProfileActionTypes.GET_PUBLIC_ANSWERS_SUCCESS:
			return {
				...state,
				loadingPublicAnswers: false,
				publicAnswersData: data,
			};
		case publicProfileActionTypes.GET_PUBLIC_ANSWERS_ERROR:
			return {
				...state,
				loadingPublicAnswers: false,
			};

		case publicProfileActionTypes.GET_ACHIEVEMENTS_REQUEST:
			return {
				...state,
				loadingAchievements: true,
			};
		case publicProfileActionTypes.GET_ACHIEVEMENTS_SUCCESS:
			return {
				...state,
				loadingAchievements: false,
				achievements: data,
			};
		case publicProfileActionTypes.GET_ACHIEVEMENTS_ERROR:
			return {
				...state,
				loadingAchievements: false,
			};

		case publicProfileActionTypes.CLEAR_PUBLIC_PROFILE_INFO:
			return {
				...state,
				loading: true,
				loadingHeaderInfo: true,
				userInfo: {},
			};

		case publicProfileActionTypes.CLEAR_PUBLIC_LISTS:
			return {
				...state,
				loading: true,
				publicLists: [],
			};

		case publicProfileActionTypes.CLEAR_PUBLIC_FOLDERS:
			return {
				...state,
				loading: true,
				publicFolders: [],
			};

		default:
			return state;
	}
}
